import { ReactElement, ReactNode } from 'react';
import cx from 'clsx';
import { formatDate } from 'utilities';
import './Period.scss';

interface PeriodProps {
  date_from: string | null;
  date_to: string | null;
  flat?: boolean;
  // ?? What does it mean
  // resets font size to inherit
  normal?: boolean;
  fmt?: (val: string) => ReactNode;
}

/** @deprecated use PeriodWidget */
export function Period({ date_from, date_to, flat, normal, fmt = formatDate }: PeriodProps): ReactElement {
  const start = date_from ? fmt(date_from) : '—';
  const end = date_to ? fmt(date_to) : '—';
  return (
    <span
      className={cx('period-container', {
        'period-container-flat': flat,
        'period-container-normal': normal,
      })}
    >
      <div className="period-form">
        {start}
        {flat && start !== end ? ' ⇢ ' : undefined}
      </div>
      {start !== end && <div className="period-to">{end}</div>}
    </span>
  );
}
